import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { Button } from '../button'
import { PlaidButton } from './plaid-button'
import { PlaidButtonProps } from './plaid-button'
import { GetPlaidLink } from './queries'

export function PlaidButtonContainer({
    onLoading,
    ...props
}: PlaidButtonProps) {
    const { data, loading } = useQuery(GetPlaidLink)
    const linkToken = useMemo(() => {
        return loading ? null : data.getConnectionLink.link_token
    }, [data, loading])


    return linkToken ? (
        <PlaidButton linkToken={linkToken} {...props} onLoading={onLoading} />
    ) : (
        <Button className={'h-16 w-64'} loading>
            Loading Plaid
        </Button>
    )
}
